import { render } from "./HouseholdClientsView.vue?vue&type=template&id=3078dddc"
import script from "./HouseholdClientsView.vue?vue&type=script&lang=js"
export * from "./HouseholdClientsView.vue?vue&type=script&lang=js"

import "./HouseholdClientsView.vue?vue&type=style&index=0&id=3078dddc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__